"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const compact_1 = __importDefault(require("lodash/compact"));
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const FilterCount_1 = __importDefault(require("src/components/filter/FilterCount"));
const FilterDate_1 = __importDefault(require("src/components/filter/FilterDate"));
const FilterSearch_1 = __importDefault(require("src/components/filter/FilterSearch"));
const FilterSort_1 = __importDefault(require("src/components/filter/FilterSort"));
const MenuFilter_1 = __importDefault(require("src/components/filter/MenuFilter"));
const ResetFilterButton_1 = __importDefault(require("src/components/filter/ResetFilterButton"));
const SelectedFilter_1 = __importDefault(require("src/components/filter/SelectedFilter"));
const CheckboxMenu_1 = __importDefault(require("src/components/filter/menu/CheckboxMenu"));
const FormalReviewFilterSection = () => {
    const { config } = (0, UserContext_1.useUser)();
    const cycleStatusOptions = (0, compact_1.default)([
        config?.endUserCyclesFilter?.includes('active') && {
            label: 'Active',
            value: 'active'
        },
        config?.endUserCyclesFilter?.includes('ended') && {
            label: 'Ended',
            value: 'ended'
        }
    ]);
    const assingmentStatusOptions = (0, compact_1.default)([
        config?.assignmentsStatusFilter?.includes('in_progress') && {
            label: 'In Progress',
            value: 'in_progress'
        },
        config?.assignmentsStatusFilter?.includes('done') && {
            label: 'Done',
            value: 'done'
        },
        config?.assignmentsStatusFilter?.includes('incomplete') && {
            label: 'InComplete',
            value: 'incomplete'
        }
    ]);
    const phaseStatusOptions = (0, compact_1.default)([
        config?.phasesStatusFilter?.includes('in_progress') && {
            label: 'In Progress',
            value: 'in_progress'
        },
        config?.phasesStatusFilter?.includes('done') && {
            label: 'Done',
            value: 'done'
        }
    ]);
    const involvementOptions = (0, compact_1.default)([
        config?.involvementCyclesFilter?.includes('individual') && {
            label: 'Individual',
            value: 'individual'
        },
        config?.involvementCyclesFilter?.includes('team') && {
            label: 'Team',
            value: 'team'
        }
    ]);
    const menuOptions = {
        name: 'Filter By',
        options: (0, compact_1.default)([
            cycleStatusOptions.length > 0 && {
                name: 'Cycle Status',
                badge: react_1.default.createElement(FilterCount_1.default, { filterKey: "status" }),
                subMenuComponent: (react_1.default.createElement(CheckboxMenu_1.default, { name: "Cycle Status", filterKey: "status", options: cycleStatusOptions }))
            },
            assingmentStatusOptions.length > 0 && {
                name: 'Assignment Status',
                badge: react_1.default.createElement(FilterCount_1.default, { filterKey: "assignmentStatus" }),
                subMenuComponent: (react_1.default.createElement(CheckboxMenu_1.default, { name: "Assignment Status", filterKey: "assignmentStatus", options: assingmentStatusOptions }))
            },
            phaseStatusOptions.length > 0 && {
                name: 'Phase Status',
                badge: react_1.default.createElement(FilterCount_1.default, { filterKey: "phaseStatus" }),
                subMenuComponent: (react_1.default.createElement(CheckboxMenu_1.default, { name: "Phase Status", filterKey: "phaseStatus", options: phaseStatusOptions }))
            },
            involvementOptions.length > 0 && {
                name: 'Involvement',
                badge: react_1.default.createElement(FilterCount_1.default, { filterKey: "involvement" }),
                subMenuComponent: (react_1.default.createElement(CheckboxMenu_1.default, { name: "Involvement", filterKey: "involvement", options: involvementOptions }))
            }
        ])
    };
    const selectedOptions = (0, react_1.useMemo)(() => [
        { key: 'status' },
        { key: 'assignmentStatus' },
        { key: 'phaseStatus' },
        { key: 'involvement' }
    ], []);
    const sortOptions = (0, react_1.useMemo)(() => [
        {
            direction: 'desc',
            id: 0,
            name: `${(0, HelperUtils_1.getObjectiveLocale)('Earliest End Date')}`,
            type: 'review_process_ends_at'
        },
        {
            direction: 'asc',
            id: 1,
            name: `${(0, HelperUtils_1.getObjectiveLocale)('Latest End Date')}`,
            type: 'review_process_ends_at'
        },
        {
            direction: 'desc',
            id: 2,
            name: `${(0, HelperUtils_1.getObjectiveLocale)('Newest ID')}`,
            type: 'id'
        },
        {
            direction: 'asc',
            id: 3,
            name: `${(0, HelperUtils_1.getObjectiveLocale)('Oldest ID')}`,
            type: 'id'
        }
    ], []);
    return (react_1.default.createElement("div", { className: "flex flex-col" },
        react_1.default.createElement("div", { className: "flex w-full" },
            react_1.default.createElement(FilterSearch_1.default, null),
            react_1.default.createElement(FilterSort_1.default, { customClass: "ml-[8px]", sortOptions: sortOptions }),
            react_1.default.createElement(FilterDate_1.default, { containerClassName: "ml-[8px]", options: config?.cyclesTimeFilterOptions })),
        react_1.default.createElement("div", { className: "flex mt-[16px]" },
            react_1.default.createElement(MenuFilter_1.default, { menuOptions: menuOptions }),
            react_1.default.createElement("div", { className: "flex flex-wrap" },
                react_1.default.createElement(SelectedFilter_1.default, { selectedOptions: selectedOptions }),
                react_1.default.createElement(ResetFilterButton_1.default, null)))));
};
exports.default = (0, react_1.memo)(FormalReviewFilterSection);
